import { createContext } from "react";
import { THEME } from "../theme";

const PageThemeContext = createContext<THEME>(THEME.LIGHT);

export default PageThemeContext;
